// extracted by mini-css-extract-plugin
export default {"section":"ManageAccountLayout_section__jhxaI","inputContainer":"ManageAccountLayout_inputContainer__tAKHI","title":"ManageAccountLayout_title__oiyK6"};